import React from 'react';
const TestimonialSection = () => {
  return <div className="my-8 bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-132">
      <h4 className="text-lg font-bold mb-4 text-center" data-id="element-133">
        Real People, Real Results
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-134">
        <div className="bg-white p-4 rounded shadow-sm" data-id="element-135">
          <div className="flex items-center mb-2" data-id="element-136">
            <div className="h-10 w-10 rounded-full bg-gray-300 mr-3" data-id="element-137"></div>
            <p className="font-semibold" data-id="element-138">Jennifer from Texas</p>
          </div>
          <p className="text-gray-700" data-id="element-139">
            "My husband is so happy, when I wear it at night I have stopped
            snoring completely."
          </p>
          <div className="flex text-yellow-400 mt-2" data-id="element-140">★★★★★</div>
        </div>
        <div className="bg-white p-4 rounded shadow-sm" data-id="element-141">
          <div className="flex items-center mb-2" data-id="element-142">
            <div className="h-10 w-10 rounded-full bg-gray-300 mr-3" data-id="element-143"></div>
            <p className="font-semibold" data-id="element-144">Mark from California</p>
          </div>
          <p className="text-gray-700" data-id="element-145">
            "Love these! I can finally breathe at night."
          </p>
          <div className="flex text-yellow-400 mt-2" data-id="element-146">★★★★★</div>
        </div>
        <div className="bg-white p-4 rounded shadow-sm" data-id="element-147">
          <div className="flex items-center mb-2" data-id="element-148">
            <div className="h-10 w-10 rounded-full bg-gray-300 mr-3" data-id="element-149"></div>
            <p className="font-semibold" data-id="element-150">David from New York</p>
          </div>
          <p className="text-gray-700" data-id="element-151">
            "I had tried many products and methods to be able to breathe at
            night. Nothing worked until I tried these."
          </p>
          <div className="flex text-yellow-400 mt-2" data-id="element-152">★★★★★</div>
        </div>
        <div className="bg-white p-4 rounded shadow-sm" data-id="element-153">
          <div className="flex items-center mb-2" data-id="element-154">
            <div className="h-10 w-10 rounded-full bg-gray-300 mr-3" data-id="element-155"></div>
            <p className="font-semibold" data-id="element-156">Lisa from Florida</p>
          </div>
          <p className="text-gray-700" data-id="element-157">
            "The very first night I used them, it was the first time in years
            that I slept through the night and actually woke up feeling rested."
          </p>
          <div className="flex text-yellow-400 mt-2" data-id="element-158">★★★★★</div>
        </div>
      </div>
    </div>;
};
export default TestimonialSection;